module.exports = __webpack_public_path__ + "static/media/ir.7bf140ab.svg";